<template>
  <div class="section section_no-padding">
    <div class="hero">
      <div class="max-width">
        <div class="hero__block">
          <div class="hero__shopify">
            <img src="@/assets/imgs/shopify-experts.svg" alt="">
            <img src="@/assets/imgs/shopify-partners.svg" alt="">
          </div>
          <div class="section__head">
            <h1 class="section__title">Shopify Themes <br>Designed to Sell</h1>
            <div class="section__text">Sales-optimized themes that focus on what works: fast performance, intuitive navigation, and layouts that convert.</div>
            <div class="section__buttons">
              <router-link to="/themes" class="button button_white">
                Explore Themes
                <IconArrow/>
              </router-link>
            </div>
          </div>
        </div>

        <div class="hero__pic">
          <img loading="lazy" srcset="@/assets/imgs/hero/pic@2x.webp 2x, @/assets/imgs/hero/pic.webp 1x" src="@/assets/imgs/hero/pic@2x.webp" alt="">
          <img loading="lazy" srcset="@/assets/imgs/hero/pic-tablet@2x.webp 2x, @/assets/imgs/hero/pic-tablet.webp 1x" src="@/assets/imgs/hero/pic-tablet@2x.webp" alt="">
        </div>
      </div>

      <div class="hero__bg">
        <img loading="lazy" srcset="@/assets/imgs/hero/bg@2x.webp 2x, @/assets/imgs/hero/bg.webp 1x" src="@/assets/imgs/hero/bg@2x.webp" alt="">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .hero {
    background:#f5f5f5;
    padding:14.75rem 0 19rem;
    position:relative;

    @include xxl {
      padding:11.75rem 0 16rem;
    }

    @include lg {
      padding:11rem 0 8rem;
    }

    @include md {
      padding:9rem 0 4rem;
    }

    @include xs {
      padding:7.5rem 0 4rem;
    }

    &__block {
      position:relative;
      z-index:2;

      .section__head {
        margin:0;
        max-width:550px;

        @include xxl {
          max-width:480px;
        }

        @include md {
          max-width:initial;
          text-align:center;
        }
      }

      .section__title {
        font-size:4rem;
        color:#fff;

        @include xxl {
          font-size:3.5rem;
        }

        @include md {
          margin-left:auto;
          margin-right:auto;
        }

        @include xs {
          font-size:3rem;
        }
      }

      .section__text {
        max-width:550px;
        color:#fff;
        opacity:.6;

        @include xxl {
          max-width:420px;
        }

        @include md {
          margin-left:auto;
          margin-right:auto;
        }
      }

      @include md {
        .section__buttons {
          justify-content:center;
        }
      }
    }

    &__shopify {
      display:flex;
      align-items:center;
      gap:.5rem;
      margin:0 0 2rem;

      @include md {
        justify-content:center;
      }
    }

    &__pic {
      right:0;
      top:50%;
      transform:translateY(-50%);
      pointer-events:none;
      z-index:2;
      position:absolute;
      padding-left:50%;

      img {
        width:100%;

        &:last-child {
          display:none;
        }
      }

      @include xxl {
        padding-left:40%;
      }

      @include lg {
        padding-left:50%;
      }

      @include md {
        padding:0;
        transform:none;
        display:flex;
        justify-content:center;
        position:relative;
        top:0;
        margin:3rem 0 0;

        img {
          display:none;

          &:last-child {
            display:block;
          }
        }
      }
    }

    &__bg {
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      z-index:1;

      img {
        width:100%;
        height:100%;
        object-fit:cover;
      }
    }
  }
</style>
<script setup>
import IconArrow from "@/components/icons/IconArrow.vue";
</script>
